import { cn } from '@/lib/utils'

const badgeVariants = {
  default: 'bg-raised text-muted',
  primary: 'bg-brand-green-soft text-brand-green',
  secondary: 'bg-brand-violet-soft text-brand-violet',
  ai: 'bg-gradient-to-r from-brand-green-soft to-brand-violet-soft text-brand-violet',
  shopify: 'bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200/50 text-emerald-700',
  marketplace: 'bg-brand-blue-soft text-brand-blue',
  success: 'bg-brand-green-soft text-brand-green',
  warning: 'bg-yellow-100 text-yellow-700',
}

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: keyof typeof badgeVariants
}

export function Badge({
  className,
  variant = 'default',
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium',
        badgeVariants[variant],
        className
      )}
      {...props}
    />
  )
}
